import { useCallback, useState } from "react";

import client from "../../client";
import { handleToast } from "../../../utils/functions";
import handleApiError from "../../../hooks/handleApiError";

export default function useCreateAcademicSession() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (payload) => {
    try {
      setLoading(true);

      const res = await client.post(`/calendar/academic-sessions`, payload);

      handleToast(res.data?.message);
      setLoading(false);

      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading };
}
